/**
 * State of applying condition of work item.
 */
export enum PersistentWorkItemApplyState {
    /**
     * Required to re-apply.
     */
    Required,

    /**
     * Skip application.
     */
    Skip
}
